import type { DepositReceiptState } from "../../../../../lib/depositReceipt";
import type { DepositSavePhase } from "./useDepositSave";

export interface DepositReceiptNoticeInput {
  phase: DepositSavePhase;
  receiptState: DepositReceiptState | null;
  /** `print_route` на избрания метод е `pos` — депозитът е без касов бон. */
  withoutReceipt: boolean;
  isCard: boolean;
}

export interface DepositReceiptNotice {
  tone: "info" | "warn";
  /** Ключът на текста; `{{error}}` — грешката на принтера от последния опит. */
  textKey: string;
}

/**
 * Лентата над формата на „Депозити": преди записа — защо бон няма (метод без
 * фискализиране) или че първо тегли терминалът; след неуспял опит — какво е
 * станало с депозита и бона и какво прави следващият натиск
 * (`useDepositSave.ts`). null — лента няма.
 */
export const depositReceiptNoticeOf = ({
  phase,
  receiptState,
  withoutReceipt,
  isCard,
}: DepositReceiptNoticeInput): DepositReceiptNotice | null => {
  if (phase === "noAnswer") return { tone: "warn", textKey: "depositLoad.noticeNoAnswer" };
  if (phase === "saved") {
    if (receiptState === "unknown") return { tone: "warn", textKey: "depositLoad.noticeUnknown" };
    if (receiptState === "card_charged") {
      return { tone: "warn", textKey: "depositLoad.noticeCardCharged" };
    }
    return { tone: "warn", textKey: "depositLoad.noticeFailed" };
  }
  if (withoutReceipt) return { tone: "info", textKey: "depositLoad.hintWithoutReceipt" };
  if (isCard) return { tone: "info", textKey: "depositLoad.hintCard" };
  return null;
};
